import { c as _c } from "react/compiler-runtime";
import React, { use } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import SuspenseWithLoader from '../SuspenseWithLoader';
import buildPdpDesktopHeroLcpUrl from './PDPDesktopHeroGallery/helpers/buildPdpDesktopHeroLcpUrl';
import PDPContextRegion from './PDPContextRegion';
import PDPContextRegionPlaceholder from './PDPContextRegionPlaceholder';
import PDPLayoutRevampSeedBoundary from './PDPLayoutRevampSeedBoundary';

/**
 * Resolves only hero-related server promises so LCP preload (and the context
 * fallback hero image) can paint without waiting on options / basicDetails /
 * stock / protection.
 */
const PDPHeroShell = t0 => {
  const $ = _c(29);
  const {
    slugOverride: t1,
    isEditOrder: t2,
    pdpIsModularBYOProduct: t3,
    productOptionsPromise,
    productHeroImagePromise,
    productCylindoHeroImagePromise,
    productBasicDetailsPromise,
    layoutRevampContextPromise
  } = t0;
  const slugOverride = t1 === undefined ? null : t1;
  const isEditOrder = t2 === undefined ? false : t2;
  const pdpIsModularBYOProduct = t3 === undefined ? false : t3;
  const productHeroImageFromServer = productHeroImagePromise ? use(productHeroImagePromise) : null;
  const productCylindoHeroImage = productCylindoHeroImagePromise ? use(productCylindoHeroImagePromise) : null;
  const heroSrcForPreload = productHeroImageFromServer?.src || productCylindoHeroImage?.src || null;
  let t4;
  if ($[0] !== heroSrcForPreload) {
    t4 = heroSrcForPreload ? buildPdpDesktopHeroLcpUrl(heroSrcForPreload) ?? heroSrcForPreload : null;
    $[0] = heroSrcForPreload;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const heroPreloadHref = t4;
  let t5;
  if ($[2] !== isEditOrder || $[3] !== pdpIsModularBYOProduct || $[4] !== productCylindoHeroImage || $[5] !== productHeroImageFromServer) {
    t5 = <PDPContextRegionPlaceholder productHeroImage={productHeroImageFromServer} productCylindoHeroImage={productCylindoHeroImage} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} />;
    $[2] = isEditOrder;
    $[3] = pdpIsModularBYOProduct;
    $[4] = productCylindoHeroImage;
    $[5] = productHeroImageFromServer;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const regionPlaceholder = t5;
  let t6;
  if ($[7] !== heroPreloadHref) {
    t6 = heroPreloadHref ? <Helmet><link rel="preload" as="image" href={heroPreloadHref} media="(min-width: 1024px)" fetchPriority="high" /></Helmet> : null;
    $[7] = heroPreloadHref;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = pdpIsModularBYOProduct || isEditOrder ? null : layoutRevampContextPromise;
  let t8;
  if ($[9] !== isEditOrder || $[10] !== pdpIsModularBYOProduct || $[11] !== productBasicDetailsPromise || $[12] !== productCylindoHeroImage || $[13] !== productHeroImageFromServer || $[14] !== productOptionsPromise || $[15] !== slugOverride) {
    t8 = <PDPContextRegion slugOverride={slugOverride} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} productOptionsPromise={productOptionsPromise} productBasicDetailsPromise={productBasicDetailsPromise} productHeroImageFromServer={productHeroImageFromServer} productCylindoHeroImage={productCylindoHeroImage} />;
    $[9] = isEditOrder;
    $[10] = pdpIsModularBYOProduct;
    $[11] = productBasicDetailsPromise;
    $[12] = productCylindoHeroImage;
    $[13] = productHeroImageFromServer;
    $[14] = productOptionsPromise;
    $[15] = slugOverride;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== regionPlaceholder || $[18] !== t8) {
    t9 = <SuspenseWithLoader fallback={regionPlaceholder}>{t8}</SuspenseWithLoader>;
    $[17] = regionPlaceholder;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7 || $[21] !== t9) {
    t10 = <PDPLayoutRevampSeedBoundary contextPromise={t7}>{t9}</PDPLayoutRevampSeedBoundary>;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== regionPlaceholder || $[24] !== t10) {
    t11 = <SuspenseWithLoader fallback={regionPlaceholder}>{t10}</SuspenseWithLoader>;
    $[23] = regionPlaceholder;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t6) {
    t12 = <>{t6}{t11}</>;
    $[26] = t11;
    $[27] = t6;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
PDPHeroShell.propTypes = {
  slugOverride: PropTypes.string,
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  productOptionsPromise: PropTypes.object,
  productHeroImagePromise: PropTypes.object,
  productCylindoHeroImagePromise: PropTypes.object,
  productBasicDetailsPromise: PropTypes.object,
  layoutRevampContextPromise: PropTypes.object
};
export default PDPHeroShell;